import type { StarterDashboardV2RootPageDataQuery } from '../rootPageData.graphql';

type Petition = NonNullable<StarterDashboardV2RootPageDataQuery['petition']>;
export function getPetitionShareVisuals(petition: Petition) {
	if (!petition.shareVisuals) return [];
	if (petition.shareVisuals.__typename !== 'ShareVisualsConnection') return [];
	return petition.shareVisuals.nodes;
}
